module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("38KM7"))).then(() => parcelRequire('f2eyU'));